import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const QrCode = t0 => {
  const $ = _c(24);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t16;
  let t17;
  let t18;
  let t19;
  let t2;
  let t20;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M15 12L15 15" strokeLinecap="round" strokeLinejoin="round" />;
    t2 = <path d="M12 3V6" strokeLinecap="round" strokeLinejoin="round" />;
    t3 = <path d="M18 12L18 15" strokeLinecap="round" strokeLinejoin="round" />;
    t4 = <path d="M12 18L21 18" strokeLinecap="round" strokeLinejoin="round" />;
    t5 = <path d="M18 21H21" strokeLinecap="round" strokeLinejoin="round" />;
    t6 = <path d="M6 12H9" strokeLinecap="round" strokeLinejoin="round" />;
    t7 = <path d="M6 6.01111L6.01 6" strokeLinecap="round" strokeLinejoin="round" />;
    t8 = <path d="M12 12.0111L12.01 12" strokeLinecap="round" strokeLinejoin="round" />;
    t9 = <path d="M3 12.0111L3.01 12" strokeLinecap="round" strokeLinejoin="round" />;
    t10 = <path d="M12 9.01111L12.01 9" strokeLinecap="round" strokeLinejoin="round" />;
    t11 = <path d="M12 15.0111L12.01 15" strokeLinecap="round" strokeLinejoin="round" />;
    t12 = <path d="M15 21.0111L15.01 21" strokeLinecap="round" strokeLinejoin="round" />;
    t13 = <path d="M12 21.0111L12.01 21" strokeLinecap="round" strokeLinejoin="round" />;
    t14 = <path d="M21 12.0111L21.01 12" strokeLinecap="round" strokeLinejoin="round" />;
    t15 = <path d="M21 15.0111L21.01 15" strokeLinecap="round" strokeLinejoin="round" />;
    t16 = <path d="M18 6.01111L18.01 6" strokeLinecap="round" strokeLinejoin="round" />;
    t17 = <path d="M9 3.6V8.4C9 8.73137 8.73137 9 8.4 9H3.6C3.26863 9 3 8.73137 3 8.4V3.6C3 3.26863 3.26863 3 3.6 3H8.4C8.73137 3 9 3.26863 9 3.6Z" strokeLinecap="round" strokeLinejoin="round" />;
    t18 = <path d="M21 3.6V8.4C21 8.73137 20.7314 9 20.4 9H15.6C15.2686 9 15 8.73137 15 8.4V3.6C15 3.26863 15.2686 3 15.6 3H20.4C20.7314 3 21 3.26863 21 3.6Z" strokeLinecap="round" strokeLinejoin="round" />;
    t19 = <path d="M6 18.0111L6.01 18" strokeLinecap="round" strokeLinejoin="round" />;
    t20 = <path d="M9 15.6V20.4C9 20.7314 8.73137 21 8.4 21H3.6C3.26863 21 3 20.7314 3 20.4V15.6C3 15.2686 3.26863 15 3.6 15H8.4C8.73137 15 9 15.2686 9 15.6Z" strokeLinecap="round" strokeLinejoin="round" />;
    $[2] = t1;
    $[3] = t10;
    $[4] = t11;
    $[5] = t12;
    $[6] = t13;
    $[7] = t14;
    $[8] = t15;
    $[9] = t16;
    $[10] = t17;
    $[11] = t18;
    $[12] = t19;
    $[13] = t2;
    $[14] = t20;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    t1 = $[2];
    t10 = $[3];
    t11 = $[4];
    t12 = $[5];
    t13 = $[6];
    t14 = $[7];
    t15 = $[8];
    t16 = $[9];
    t17 = $[10];
    t18 = $[11];
    t19 = $[12];
    t2 = $[13];
    t20 = $[14];
    t3 = $[15];
    t4 = $[16];
    t5 = $[17];
    t6 = $[18];
    t7 = $[19];
    t8 = $[20];
    t9 = $[21];
  }
  let t21;
  if ($[22] !== props) {
    t21 = <IconWrapper {...props} variant="outline">{t1}{t2}{t3}{t4}{t5}{t6}{t7}{t8}{t9}{t10}{t11}{t12}{t13}{t14}{t15}{t16}{t17}{t18}{t19}{t20}</IconWrapper>;
    $[22] = props;
    $[23] = t21;
  } else {
    t21 = $[23];
  }
  return t21;
};
export { QrCode };